// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1RY4q","content":"RecentSearches_content__1p_I2"};